// extracted by mini-css-extract-plugin
export default {"cls1":"_IBvnQHcDrYSKxn7sRHx","cls2":"OpACXGOPtrW9cA3LUaR6 _IBvnQHcDrYSKxn7sRHx"};